import { tv } from 'tailwind-variants';

export const calendarStyles = tv({
  slots: {
    root: 'w-fit bg-white border border-gray-300 rounded-lg p-2',
    months: 'flex flex-col',
    month: 'flex flex-col gap-1',
    monthCaption: 'flex items-center gap-2 w-full',
    captionLabel: 'flex-1 text-center text-base font-bold text-gray-700 capitalize',
    monthGrid: 'border-separate border-spacing-x-0 border-spacing-y-1',
    weekday: 'text-sm font-medium text-gray-700',
    day: 'px-0.5 py-0 text-center',
    dayRangeStart: 'bg-[linear-gradient(to_right,transparent_2px,theme(colors.green.100)_2px)]',
    dayRangeMiddle: 'bg-green-100',
    dayRangeEnd: 'bg-[linear-gradient(to_left,transparent_2px,theme(colors.green.100)_2px)]',
  },
});

export const navButtonStyles = tv({
  slots: {
    button: 'group flex items-center justify-center p-2 disabled:cursor-not-allowed',
    circle: 'flex items-center justify-center size-5 rounded-full transition-colors',
    icon: 'text-sm',
  },
  variants: {
    disabled: {
      true: { circle: 'bg-gray-100', icon: 'text-gray-400' },
      false: { circle: 'bg-green-100 group-hover:bg-green-200', icon: 'text-green-500' },
    },
  },
  defaultVariants: {
    disabled: false,
  },
});

export const dayButtonStyles = tv({
  base: [
    'flex items-center justify-center size-9 rounded text-base font-medium text-gray-700',
    'transition-colors cursor-pointer hover:bg-green-100',
    'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-green-500 focus-visible:ring-offset-1',
  ],
  variants: {
    selected: {
      true: '!bg-green-500 !text-white hover:!bg-green-600',
    },
    today: {
      true: 'font-bold text-green-500',
    },
    outside: {
      true: 'text-gray-400',
    },
    disabled: {
      true: '!text-gray-300 hover:!bg-transparent cursor-not-allowed',
    },
  },
});

export const datePickerStyles = tv({
  slots: {
    container: 'flex flex-col gap-1 w-full',
    label: 'text-sm font-semibold text-gray-700',
    field: [
      'flex items-center gap-2 w-full bg-white overflow-hidden',
      'border border-gray-300 rounded-lg pl-4 pr-2',
      'transition-colors focus-within:border-gray-500',
    ],
    input: [
      'flex-1 min-w-0 bg-transparent py-2.5 outline-none',
      'text-base text-gray-700 placeholder:text-gray-500',
    ],
    iconButton: [
      'flex items-center justify-center p-2 shrink-0 rounded-md text-gray-500',
      'transition-colors hover:text-gray-700 cursor-pointer',
      'outline-none focus-visible:ring-2 focus-visible:ring-green-500',
    ],
    icon: 'text-xl',
    error: 'text-sm text-danger-500',
  },
  variants: {
    open: {
      true: { field: 'border-gray-500' },
    },
    hasError: {
      true: { field: 'border-danger-500 focus-within:border-danger-500' },
    },
    disabled: {
      true: {
        field: 'bg-gray-100 border-gray-300',
        input: 'text-gray-400 placeholder:text-gray-400 cursor-not-allowed',
        iconButton: 'text-gray-400 cursor-not-allowed hover:text-gray-400',
      },
    },
  },
});
